import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { IDatingProfileModel } from '../../../models/dating.model';
import InputComponent from '../../../components/input/input.component';
import Select, { IOption } from '../../../select/select.component';
import ReactSelect, { MultiValue } from 'react-select';
import { useDarkMode } from '../../../hooks';
import { fetchAllCategory } from '../../../api';
import ButtonSecondary from '../../../components/button-refactor/button-secondary';
import ButtonPrimary from '../../../components/button-refactor/button-primary';
import toast from 'react-hot-toast';
import { datingService } from '../../../services/dating.service';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import ErrorValidateComponent from '../../../components/error-validate/error-validate.component';
import { InputWarning } from '../../../components/inputwarning/input-warning.component';

const options: IOption[] = [
  {
    label: 'Nam',
    value: 'male',
  },
  {
    label: 'Nữ',
    value: 'female',
  },
  {
    label: 'Tùy chọn',
    value: 'other',
  },
];

const optionsPreferredGender: IOption[] = [
  {
    label: 'Nam',
    value: 'MALE',
  },
  {
    label: 'Nữ',
    value: 'FEMALE',
  },
];

interface EditProfileGeneralProps {
  profile?: IDatingProfileModel;
  cities?: IOption[];
  getDatingProfile?: () => void;
}

const schema = yup.object().shape({
  age: yup
    .number()
    .required('Vui lòng nhập tuổi')
    .typeError('Vui lòng nhập')
    .optional(),
  height: yup
    .number()
    .required('Vui lòng nhập chiều cao')
    .typeError('Vui lòng nhập')
    .optional(),
  weight: yup
    .number()
    .required('Vui lòng nhập cân nặng')
    .typeError('Vui lòng nhập')
    .optional(),
});

interface IFormValues {
  nickname?: string;
  age?: number;
  height?: number;
  weight?: number;
  gender?: string;
  birthDay?: string;
  description?: string;
  additionLocation?: string;
  cityId?: string;
  albumUrls?: string[];
  interestIds?: string[];
  preferredGender?: string;
  preferredAge?: number;
  education?: string;
  occupation?: string;
  customGender?: string;
}

const ProfileUseDating = ({
  profile,
  cities,
  getDatingProfile,
}: EditProfileGeneralProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { isDarkMode } = useDarkMode();

  // const openEditProfile = () => {
  //   setVisible(true);
  // };

  const [categoryOptions, setCategoryOptions] = useState<IOption[]>([]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm<IFormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      nickname: profile?.nickname,
      age: profile?.age,
      gender: profile?.gender,
      birthDay: profile?.birthDay,
      description: profile?.description,
      additionLocation: profile?.additionLocation,
      cityId: profile?.cityId,
      albumUrls: profile?.albumUrls || [],
      interestIds: profile?.interestIds || [],
      preferredGender: profile?.preferredGender?.toUpperCase(),
      preferredAge: profile?.preferredAge,
      education: profile?.education,
      occupation: profile?.occupation,
    },
  });

  const fetchCategoryOptions = async () => {
    try {
      // Replace this URL with the actual endpoint from which you're fetching category options
      const response = await fetchAllCategory();
      const data: any[] = response.map((item: any) => ({
        value: item.id,
        label: item.name,
      }));
      setCategoryOptions(data);
      // Optionally, update form default values here if necessary
    } catch (error) {
      console.error('Failed to fetch category options:', error);
    }
  };

  useEffect(() => {
    fetchCategoryOptions();
  }, []);

  useEffect(() => {
    if (profile) {
      reset({
        nickname: profile.nickname,
        age: profile.age,
        gender: profile.gender,
        birthDay: profile.birthDay,
        description: profile.description,
        additionLocation: profile.additionLocation,
        cityId: profile.cityId,
        albumUrls: profile.albumUrls || [],
        interestIds: profile.interestIds || [],
        preferredGender: profile.preferredGender?.toUpperCase(),
        preferredAge: profile.preferredAge,
        education: profile.education,
        occupation: profile.occupation,
        height: profile.height,
        weight: profile.weight,
      });
    }
  }, [profile, reset]);

  const onSubmit: SubmitHandler<IFormValues> = async (formValues) => {
    console.log(
      '❤️ ~ constonSubmit:SubmitHandler<IFormValues>= ~ formValues:',
      formValues
    );
    try {
      setLoading(true);
      const gender =
        formValues.gender === 'other'
          ? formValues.customGender
          : formValues.gender;
      // Ép kiểu số (ô nhập là text -> tránh gửi chuỗi rỗng/NaN làm BE bind int fail -> 400)
      const toNum = (v: any) => {
        const n = Number(v);
        return isNaN(n) ? 0 : n;
      };
      const payload = {
        ...profile,
        ...formValues,
        gender: gender || 'Chưa rõ',
        age: toNum(formValues.age ?? profile?.age),
        height: toNum(formValues.height ?? profile?.height),
        weight: toNum(formValues.weight ?? profile?.weight),
        preferredAge: toNum(formValues.preferredAge ?? profile?.preferredAge),
        // Enum BE không nhận chuỗi rỗng; chuẩn hoá về MALE/FEMALE (parse case-insensitive)
        preferredGender: (
          formValues.preferredGender ||
          profile?.preferredGender ||
          'MALE'
        )
          .toString()
          .toUpperCase(),
        albumUrls: formValues.albumUrls || [],
      };
      await datingService.updateDatingProfile(payload as IDatingProfileModel);
      toast.success('Cập nhật thông tin thành công');
      getDatingProfile && getDatingProfile();
    } catch (error) {
      toast.error('Không thể cập nhật tài khoản của bạn');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex border rounded-xl w-full border-[#DEE0E6] dark:border-slate-700">
      <form className="w-full text-[#18191E] dark:text-white" onSubmit={handleSubmit(onSubmit)}>
        <h5 className=" text-[22px] leading-6 px-4 py-3 font-semibold">
          Thông tin cá nhân
        </h5>
        <div className="px-6 py-4 w-full flex flex-col gap-4 ">
          <div className="flex w-full flex-col gap-4 p-3 bg-[#F7F7F7] dark:bg-dark2 rounded ">
            <span className="text-[18px] leading-6 font-medium">
              Thông tin căn bản
            </span>
            <div className="flex gap-4">
              <div className="flex flex-col gap-4  w-full">
                <div className="form-group ">
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="description"
                      className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                    >
                      Giới thiệu&nbsp;
                      <InputWarning />
                    </label>
                    <div className="w-full">
                      <InputComponent
                        className="h-12"
                        placeholder="Giới thiệu bản thân của bạn bằng 1 vài câu hoặc 1 vài dòng để người khác biết bạn hơn.... "
                        id="description"
                        register={register('description')}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="nickname"
                      className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                    >
                      Tên hiển thị&nbsp;
                      <InputWarning />
                    </label>
                    <div className="w-full">
                      <InputComponent
                        className="h-12"
                        placeholder="Tên hiển thị"
                        id="nickname"
                        register={register('nickname')}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group ">
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="cityId"
                      className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                    >
                      Thành phố&nbsp;
                      <InputWarning />
                    </label>
                    <div className="w-full flex gap-2">
                      <div className="w-full  font-normal">
                        <Select
                          className="bg-[#f1f5f9] dark:bg-slate-800 h-12"
                          options={cities || []}
                          onChange={(data: any) => {
                            setValue('cityId', data.value);
                          }}
                          placeholder="Thành phố"
                          value={watch('cityId')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group ">
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="gender"
                      className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                    >
                      Giới tính&nbsp;
                      <InputWarning />
                    </label>
                    <div className="w-full flex gap-2">
                      <div className="w-full  font-normal">
                        <Select
                          className="bg-[#f1f5f9] dark:bg-slate-800 h-12"
                          options={options}
                          onChange={(data: any) => {
                            setValue('gender', data.value);
                          }}
                          placeholder="Giới tính"
                          value={watch('gender')}
                        />
                      </div>
                      {watch('gender') === 'other' && (
                        <InputComponent
                          className="h-12"
                          placeholder="Nhập giới tính"
                          register={register('customGender')}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-4 w-full">
                <div className="form-group ">
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="height"
                      className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                    >
                      Chiều cao&nbsp;
                      <InputWarning />
                    </label>
                    <div className="w-full">
                      <InputComponent
                        className="h-12"
                        placeholder="Chiều cao"
                        id="height"
                        register={register('height')}
                      />
                      <ErrorValidateComponent visible={!!errors.height}>
                        {errors.height?.message}
                      </ErrorValidateComponent>
                    </div>
                  </div>
                </div>
                <div className="form-group ">
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="weight"
                      className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                    >
                      Cân nặng&nbsp;
                      <InputWarning />
                    </label>
                    <div className="w-full">
                      <InputComponent
                        className="h-12"
                        placeholder="Cân nặng"
                        id="weight"
                        register={register('weight')}
                      />
                      <ErrorValidateComponent visible={!!errors.weight}>
                        {errors.weight?.message}
                      </ErrorValidateComponent>
                    </div>
                  </div>
                </div>

                <div className="form-group ">
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="age"
                      className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                    >
                      Tuổi&nbsp;
                      <InputWarning />
                    </label>
                    <div className="w-full">
                      <InputComponent
                        className="h-12"
                        placeholder="Tuổi"
                        id="age"
                        register={register('age')}
                      />
                      <ErrorValidateComponent visible={!!errors.age}>
                        {errors.age?.message}
                      </ErrorValidateComponent>
                    </div>
                  </div>
                </div>

                <div className="form-group ">
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="birthDay"
                      className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                    >
                      Ngày sinh&nbsp;
                      <InputWarning />
                    </label>
                    <div className="w-full">
                      <InputComponent
                        className="h-12"
                        placeholder="Ngày sinh"
                        id="birthDay"
                        register={register('birthDay')}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group ">
              <div className="flex flex-col gap-1">
                <label
                  htmlFor="education"
                  className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                >
                  Địa chỉ cụ thể&nbsp;
                  <InputWarning />
                </label>
                <div className="w-full">
                  <InputComponent
                    className="h-12"
                    placeholder="Địa chỉ"
                    id="additionLocation"
                    register={register('additionLocation')}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex w-full flex-col gap-4 p-3 bg-[#F7F7F7] dark:bg-dark2 rounded ">
            <span className="text-[18px] leading-6 font-medium">
              Nơi làm việc và học vấn
            </span>
            <div className="flex gap-4 w-full">
              <div className="form-group w-full">
                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="occupation"
                    className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                  >
                    Nghề nghiệp &nbsp;
                    <InputWarning />
                  </label>
                  <div className="w-full">
                    <InputComponent
                      className="h-12"
                      placeholder="Nghề nghiệp"
                      id="occupation"
                      register={register('occupation')}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group w-full ">
                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="education"
                    className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                  >
                    Học vấn&nbsp;
                    <InputWarning />
                  </label>
                  <div className="w-full">
                    <InputComponent
                      className="h-12"
                      placeholder="Học vấn"
                      id="education"
                      register={register('education')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex w-full flex-col gap-4 p-3 bg-[#F7F7F7] dark:bg-dark2 rounded ">
            <span className="text-[18px] leading-6 font-medium">Lối sống</span>
            <div className="form-group ">
              <div className="flex flex-col gap-1">
                <label
                  htmlFor="categoryFavorites"
                  className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                >
                  Sở thích&nbsp;
                  <InputWarning />
                </label>
                <div className="w-full flex gap-2">
                  <ReactSelect
                    isMulti
                    options={categoryOptions}
                    onChange={(selectedOptions: MultiValue<any>) => {
                      setValue(
                        'interestIds',
                        selectedOptions.map((option) => option.value)
                      );
                    }}
                    placeholder="Sở thích"
                    value={categoryOptions.filter((option) => {
                      if (watch('interestIds')) {
                        return watch('interestIds')?.includes(option.value);
                      }
                      return false;
                    })}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: '100%',
                        height: '48px',
                      }),
                      control: (provided) => ({
                        ...provided,
                        width: '100%',
                        height: '48px',
                        backgroundColor: isDarkMode ? '#1e293b' : '#ffffff',
                        borderColor: isDarkMode ? '#334155' : '#C8CCD8',
                      }),
                      menu: (provided) => ({
                        ...provided,
                        backgroundColor: isDarkMode ? '#1e293b' : '#ffffff',
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? isDarkMode
                            ? '#334155'
                            : '#F6F7F8'
                          : 'transparent',
                        color: isDarkMode ? '#f8fafc' : '#111827',
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: isDarkMode ? '#334155' : '#e2e8f0',
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: isDarkMode ? '#f8fafc' : '#111827',
                      }),
                      input: (provided) => ({
                        ...provided,
                        color: isDarkMode ? '#f8fafc' : '#111827',
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: isDarkMode ? '#94a3b8' : '#94a3b8',
                      }),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex w-full flex-col gap-4 p-3 bg-[#F7F7F7] dark:bg-dark2 rounded ">
            <span className="text-[18px] leading-6 font-medium">
              Sở thích - Xu hướng
            </span>
            <div className="flex gap-4 w-full">
              <div className="form-group w-full ">
                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="gender"
                    className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                  >
                    Xu hướng giới tính&nbsp;
                    <InputWarning />
                  </label>
                  <div className="w-full flex gap-2">
                    <div className="w-full  font-normal">
                      <Select
                        className="bg-[#f1f5f9] dark:bg-slate-800 h-12"
                        options={optionsPreferredGender}
                        onChange={(data: any) => {
                          setValue('preferredGender', data.value);
                        }}
                        placeholder="Xu hướng giới tính"
                        value={watch('preferredGender')}
                      />
                    </div>
                    {/* {watch('preferredGender') === 'other' && (
                      <InputComponent placeholder="Nhập giới tính" register={register('customGender')} />
                    )} */}
                  </div>
                </div>
              </div>
              <div className="form-group  w-full">
                <div className="flex flex-col gap-1">
                  <label
                    htmlFor="preferredAge"
                    className="flex items-center w-full text-sm text-slate-800 dark:text-slate-50 "
                  >
                    Xu hướng tuổi&nbsp;
                    <InputWarning />
                  </label>
                  <div className="w-full">
                    <InputComponent
                      className="h-12"
                      placeholder="Để hiểu rõ xu hướng tuổi mà bạn mong muốn"
                      id="preferredAge"
                      register={register('preferredAge')}
                      type="number"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-6 border-t border-t-[#DEE0E6] dark:border-t-slate-700 flex gap-2 justify-end items-center">
          {/* <ButtonSecondary
            className="dark:text-slate-50 h-10 px-4 py-2 rounded-lg border border-solid !border-[#DEE0E6] dark:border-slate-700 text-base text-[#18191E] cursor-pointer font-medium"
            onClick={() => {}}
          >
            Hủy bỏ
          </ButtonSecondary> */}
          <ButtonPrimary
            className="h-10 px-4 py-2 text-base bg-[#0071A6]"
            loading={loading}
            disabled={loading}
          >
            Lưu thay đổi
          </ButtonPrimary>
        </div>
      </form>
    </div>
  );
};

export default ProfileUseDating;
